import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';
import Shimmer from '../Shimmer/Shimmer';
import MenuPageHeader from '../MenuPageHeader';
import useAuth from '../../hooks/useAuth';
import couponImage from '../../common/assets/svg/coupon.svg';
import { ReactComponent as CouponImage } from '../../common/assets/svg/coupon.svg';

import CouponDetailsModal from '../couponPopups/CouponDetailsModal';
import CouponSuccessPopup from '../couponPopups/CouponSuccessModal';
import backArrow from '../../common/assets/svg/BackTopArrow.svg';
import { useDispatch } from 'react-redux';
import {
  clearPlaceOrderLoading,
  couponClicked,
  removeCartTip,
  setNotip,
  setTipAdded,
  toggleCartView,
} from '../../common/features/cart/cartActions';
import notFound from '../../common/assets/svg/couponNotFound.svg';
import {
  appliedCoupon,
  clearAppliedCoupon,
  getCouponRequest,
  validateCouponClearmsg,
  validateCouponRequest,
} from '../../common/features/restaurant/restaurantAction';
import { useLocation, useNavigate, useParams } from 'react-router';
import InvalidCoupon from '../couponPopups/InvalidCoupon';
interface CouponData {
  setShowSuccessPopup?: any;
  showSuccessPopup?: any;
}

const CouponList: React.FC<CouponData> = ({ setShowSuccessPopup, showSuccessPopup }) => {
  const restaurantDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantDetailLoading
  );
  const [couponCardapplyClicked, setCouponCardapplyClicked] = useState(false);
  const appliedCoupondata = useSelector((state: any) => state.restaurant.appliedCoupon);
  const couponValidationmsg = useSelector((state: any) => state.restaurant.validateCouponmsg);
  const isCartViewVisible = useSelector((state: any) => state.cart.isCartViewVisible);

  const cart = useSelector((state: any) => state.cart.cart.items);
  const location = useLocation();
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const { merchantType, merchantSlug, menuType, tableId } = useParams();
  const navigate = useNavigate();
  const couponsListLoading = useSelector((state: any) => state.restaurant.getCouponLoading);
  const couponsListSuccess = useSelector((state: any) => state.restaurant.getCouponSuccess);
  const couponsListFaliure = useSelector((state: any) => state.restaurant.getCouponFaliure);
  const couponsList = useSelector((state: any) => state.restaurant.getCouponData);
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);
  const [signupPopup, setSignupPopup] = useState(false);
  const [showSuccessPopupMobile, setShowSuccessPopupMobile] = useState<boolean>();
  const [showCouponDetailsPopup, setShowCouponDetailsPopup] = useState(false);
  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
  const validateCouponSuccess = useSelector((state: any) => state.restaurant.validateCouponSuccess);
  const [showCouponPopup, setShowCouponPopup] = useState(false);

  const { handleLogout } = useAuth();
  const dispatch = useDispatch();
  const toggleCart = () => {
    dispatch(toggleCartView(true));
  };
  const slugFromLocalStorage =
    localStorage?.getItem('restaurant') && JSON?.parse(localStorage?.getItem('restaurant') || '');
  const locationID = useSelector((state: any) => state.restaurant.currentRestaurantDetail.id);
  const currentOrderTypeName = restaurantDetails?.orderTypes?.find(
    (o: any) => slugFromLocalStorage?.menuType === o?.typeName
  )?.typeName;
    
  const UserId = localStorage.getItem('USER_ID');
  const eventName = localStorage.getItem('isEventOrder') || '';
  const customerId = localStorage.getItem('USER_ID');
  useEffect(() => {
    if (locationID) {
      const getCouponPayload = {
        locationId: locationID,
        couponId: null,
        customerId: customerId,
        orderType: currentOrderTypeName,
        visibleTo: 'C',
      };
      dispatch(getCouponRequest(getCouponPayload));
    }
  }, []);

  useEffect(() => {
    if (cart?.length < 1 && location?.pathname?.includes('/coupons')) {
      dispatch(setNotip(''));
      dispatch(setTipAdded(false));
      dispatch(removeCartTip());
      if (!tableId) {
        if (isEventDate) {
          navigate(
            `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}/event/${eventName}`
          );
        } else {
          navigate(
            `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
          );
        }
      } else {
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}`
        );
      }
    }
  }, [cart]);
  const [couponState, setCouponState] = useState();
  const [couponSearch, setCouponSearch] = useState('');
  const [couponSearchError, setCouponSearchError] = useState<any>();
  const totals = useSelector((state: any) => state.cart.totalDetails);
  const itemTotal = totals?.orderTotals?.find((t: any) => t.code === '1')?.value;
  const selectedCouponId = couponsList?.filter((item: any) => item.offerCode === couponSearch);

  useEffect(() => {
    if (couponValidationmsg && couponValidationmsg.status === 400) {
      if (couponSearch !== '') {
        setCouponSearchError(couponValidationmsg);
        // setCouponCardapplyClicked(false);
      }
    } else {
      // if (couponValidationmsg.status === 200) {
      //   dispatch(appliedCoupon({ offerCode: couponSearch, id: selectedCouponId[0]?.id }));
      // }
      // setCouponCardapplyClicked(true);
      setCouponSearchError('');
    }
  }, [couponValidationmsg]);

  useEffect(() => {
    if (couponValidationmsg && couponValidationmsg.status === 400 && couponCardapplyClicked) {
      setShowCouponPopup(true);
    } else {
      setShowCouponPopup(false);
    }
  }, [couponValidationmsg, couponCardapplyClicked]);

  const CouponCard = ({ name, attributes, price, couponDetails }: any) => {
    const disabledtheApplyBtn = Number(itemTotal) >= Number(couponDetails?.minOrderAmount);

    const isFlatFee = couponDetails?.offerType === 'FLATFEE';

    const currencySymbol =
      attributes?.currencyType === 'USD' ? '$' : attributes?.currencyType === 'IN' ? '₹' : '';

    const offerRate = parseFloat(couponDetails?.offerRate);

    const formattedRate = isFlatFee
      ? offerRate.toFixed(2) // 4.00
      : Number.isInteger(offerRate)
      ? offerRate // 4
      : offerRate; // 4.5

    const offerText = isFlatFee
      ? `Flat ${currencySymbol}${formattedRate} Off`
      : `${formattedRate}% Off`;
    return (
      <div className="couponCard-wrapper">
        <div
          className="couponCard"
          onClick={() => {
            setShowCouponDetailsPopup(true);
            setCouponState(couponDetails);
          }}
        >
          <p className="couponCard-heading">{name}</p>

          <p className="couponCard-offer">{offerText}</p>

          {attributes?.description !== '' && (
            <p className="couponCard-desc">{attributes?.description}</p>
          )}

          <div className="couponCard-button-container">
            <p
              className="couponCard-Terms-Conditions"
              onClick={() => {
                setShowCouponDetailsPopup(true);
                setCouponState(couponDetails);
              }}
            >
              Terms & Condition
            </p>
            {couponDetails?.id === appliedCoupondata?.id ? (
              <div
                className={`couponCard-remove-button`}
                onClick={e => {
                  e.stopPropagation();
                  dispatch(clearAppliedCoupon());
                }}
              >
                Remove
              </div>
            ) : (
              <div
                className={`couponCard-Apply-button ${
                  !disabledtheApplyBtn ? 'disabled-applybtn' : ''
                }`}
                onClick={e => {
                  e.stopPropagation();
                  if (disabledtheApplyBtn) {
                    // dispatch(appliedCoupon(couponDetails));
                    const payload = {
                      customerId: UserId,
                      couponCode: couponDetails?.offerCode,
                      locationId: restaurantDetails?.id,
                      orderTotal: itemTotal,
                      couponId: couponDetails?.id,
                    };
                    setCouponCardapplyClicked(true);
                    // dispatch(appliedCoupon({ offerCode: couponSearch,id:selectedCouponId[0]?.id }));

                    dispatch(validateCouponRequest(payload));
                    setCouponState(couponDetails);
                    // dispatch(couponClicked());
                    // if (isMobile) {
                    //   setShowSuccessPopupMobile(true);
                    // } else {
                    //   setShowSuccessPopup(true);
                    // }
                  }
                }}
              >
                Apply
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="couponList">
      {restaurantDetailLoading || couponsListLoading ? (
        <Shimmer />
      ) : (
        <>
          <div className="couponList-header-container">
            {isMobile && (
              <div className="mobile-view">
                <MenuPageHeader
                  Switch={false}
                  Logoutfn={() => handleLogout('noRedirect')}
                  signupPopup={signupPopup}
                  setSignupPopup={setSignupPopup}
                />
              </div>
            )}
          </div>

          <div
            className="couponList-content"
            style={{
              backgroundColor: isMobile ? '' : '#f5f5f5',
              marginTop: isMobile ? '0px' : '-0.95rem',
              borderRight: isMobile ? '' : '0.5px solid #606060',
            }}
          >
            <div
              className="couponList-heading"
              style={{ paddingTop: isMobile ? '0.5rem' : '1rem' }}
            >
              {!isMobile && (
                <img
                  src={backArrow}
                  alt=""
                  className="couponList-heading-backArrow"
                  onClick={() => dispatch(couponClicked(false))}
                />
              )}
              <p>Apply Coupon</p>
            </div>
            {/* coupon input field */}
            <div className="couponList-search-wrapper">
              <CouponImage className="coupon-image" />
              {/* <img src={couponImage} alt="coupon-image"  /> */}
              <div className="couponList-searchBox">
                <input
                  type="text"
                  className={`couponList-search ${
                    couponSearchError !== '' && !couponCardapplyClicked
                      ? 'couponList-search-error'
                      : ''
                  }`}
                  value={couponSearch}
                  placeholder="Enter Coupon Code"
                  onChange={e => {
                    const value = e.target.value;
                    setCouponSearch(value?.replace(/^\s+/, ''));
                  }}
                />
              </div>
              <p
                className="couponList-apply-button"
                onClick={() => {
                  // setShowCouponDetailsPopup(true)
                  if (couponSearch?.length && appliedCoupondata?.offerCode !== couponSearch) {
                    const payload = {
                      customerId: UserId,
                      couponCode: couponSearch,
                      locationId: restaurantDetails?.id,
                      orderTotal: itemTotal,
                      couponId: selectedCouponId[0]?.id,
                    };
                    setCouponCardapplyClicked(false);
                    dispatch(validateCouponRequest(payload));
                  }
                }}
              >
                Apply
              </p>
            </div>
            {/* coupon input field */}
            {couponSearchError !== '' && !couponCardapplyClicked && (
              <div className="coupon-validate-error">
                <p className="coupon-validate-error-text">{couponSearchError?.message}</p>
              </div>
            )}

            <div className="couponList-coupon-list">
              <div
                className="couponList-coupon-list-wrapper">
                {couponsList?.length > 0 ? (
                  couponsList?.map((coupon: any) => {
                    return (
                      <CouponCard
                        name={coupon.offerCode}
                        attributes={JSON.parse(coupon?.attributes)}
                        price={parseFloat(coupon?.offerRate)?.toFixed(2)}
                        couponDetails={coupon}
                      />
                    );
                  })
                ) : (
                  <img src={notFound} alt="" className="couponList-not-found" />
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <CouponDetailsModal
        couponDetails={couponState}
        open={showCouponDetailsPopup}
        onApply={() => {
          setShowCouponDetailsPopup(false);

          if (isMobile) {
            setShowSuccessPopupMobile(true);
          } else {
            setShowSuccessPopup(true);
            // dispatch(couponClicked());
          }
        }}
        onClose={() => {
          setShowCouponDetailsPopup(false);
        }}
      />

      <InvalidCoupon
        open={showCouponPopup}
        onClose={() => {
          dispatch(validateCouponClearmsg());
          dispatch(clearPlaceOrderLoading());
          setShowCouponPopup(false);
        }}
      />
      {couponCardapplyClicked && (
        <CouponSuccessPopup
          couponDetails={couponState}
          open={(isMobile ? showSuccessPopupMobile : showSuccessPopup) || validateCouponSuccess}
          onClose={() => {
            setShowSuccessPopupMobile(false);
            if (!isMobile) {
              dispatch(couponClicked(false));
              setShowSuccessPopup(false);
            } else {
              if (tableId) {
                navigate(
                  `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/cart`
                );
              } else {
                navigate(`/${merchantType}/${merchantSlug}/cart`);
              }
            }
          }}
        />
      )}
    </div>
  );
};

export default CouponList;
